import { render, staticRenderFns } from "./TransplantationEditor.vue?vue&type=template&id=5c485678&"
import script from "./TransplantationEditor.vue?vue&type=script&lang=ts&"
export * from "./TransplantationEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports